/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { PartsAgreementRestResponse } from '../../models/parts-agreement-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface FindPartsAgreementById$Params {
  id: number;
}

export function findPartsAgreementById(
  http: HttpClient,
  rootUrl: string,
  params: FindPartsAgreementById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PartsAgreementRestResponse>> {
  const rb = new RequestBuilder(rootUrl, findPartsAgreementById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartsAgreementRestResponse>;
    }),
  );
}

findPartsAgreementById.PATH = '/parts-agreement/{id}';
